const items = [
    "Vishnupad Temple",
    "Falgu River Ghat",
    "Akshayavat Vriksh",
    "Pretshila Hill",
    "Ram Kunda",
    "45 Sacred Vedis",
    "Traditional Gayawal Pandas",
    "Pitru Moksha",
];

export const Marquee = () => (
    <div data-testid="sacred-marquee" className="bg-[#241D19] py-4 overflow-hidden border-y border-[#D4AF37]/30">
        <div className="marquee-track flex whitespace-nowrap">
            {[0, 1].map((copy) => (
                <div key={copy} className="flex shrink-0">
                    {items.map((item, i) => (
                        <span
                            key={`${copy}-${i}`}
                            className="font-serif-alt italic text-amber-100/80 text-lg mx-6 flex items-center gap-6"
                        >
                            {item}
                            <span className="text-[#D4AF37] not-italic text-xs">✦</span>
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);
